import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Service, inject } from '@angular/core';

/** Respiro acima do bloco de etapas, para ele não encostar na borda da viewport. */
const RESPIRO_ETAPA = 24;

/**
 * Reposicionamento usado nas ações de navegação do portal: paginação e troca de
 * etapa abrem o conteúdo a partir do topo e sem animação de rolagem. A sensação
 * de fluidez fica por conta da transição de entrada do conteúdo, e não do scroll.
 */
@Service()
export class ScrollNavegacaoService {
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);

  /**
   * Encosta um bloco no topo da viewport, sem animar. `deslocamento` recua a
   * parada em pixels, para deixar uma folga acima do elemento.
   */
  aoElemento(elemento: HTMLElement | null | undefined, deslocamento = 0): void {
    if (!isPlatformBrowser(this.platformId) || !elemento) return;

    const janela = this.document.defaultView;
    if (!janela) return;

    const topo = elemento.getBoundingClientRect().top + janela.scrollY - deslocamento;

    janela.scrollTo({ top: Math.max(topo, 0), left: 0, behavior: 'auto' });
  }

  /** Início da etapa recém-aberta: a trilha de etapas e, logo abaixo, o conteúdo dela. */
  aoInicioDaEtapa(elemento: HTMLElement | null | undefined): void {
    this.aoElemento(elemento, RESPIRO_ETAPA);
  }
}
